<template>
    <span v-if="col.isEdit && col.type === 'dialog' && col.click" style='width: 100%;' @click='col.click(data);'>
        {{ col.filterData(data, field) }}
    </span>

    <!--    自定义单元格文本的样式  dynamicClass(data, rowData, columnDefine) 函数类型   -->
    <span v-else-if='col.dynamicClass && Object.prototype.toString.call(col.dynamicClass) === "[object Function]"'
        :class='col.dynamicClass(data[field], toRaw(data), toRaw(col))'>
        {{ col.filterData && Object.prototype.toString.call(col.filterData) === '[object Function]' ?
            col.filterData(data[field]) : data[field]
        }}
    </span>

    <!--    默认单元格文本样式      -->
    <span :class="col.filterData ? 'Bio_' + dynamicClass(col.filterData(data[field])) : ''">
         {{ col.pattern ? changeTime(data[field], col.pattern) : (col.filterData ? col.filterData(data[field]) : data[field]
        ) }}
    </span>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        col: {
            type: Object,
            default: () => { }
        },
        data: {
            type: Object,
            default: () => { }
        },
        field: {
            type: String,
            default: ''
        }
    },
    methods: {
        changeTime(time, pattern) {
            console.log(time,'---')
            return time ? moment(time).format(pattern) : '' 
        },
        dynamicClass(data) {
            switch (data) {
                case '完成':
                    return 'complete';
                case '录入完成':
                    return 'inputCompleted';
                case '已发运':
                    return 'dispatched';
                case '已运输':
                    return 'unSubmitted';
                case '成品已接收':
                    return 'finishedProductReceived';
                case '新建':
                    return 'new';
                case '无效':
                    return 'invalid';
                case '取消':
                    return 'underReview';
                case '有效':
                    return 'valid';
                case '失效':
                    return 'loseEfficacy';
                case '审核中':
                    return 'underReview';
                case '已作废':
                    return 'haveBeenCancelled';
                case '作废':
                    return 'haveBeenCancelled';
                case '已退回':
                    return 'returned';
                case '样本已接收':
                    return 'sampleReceived';
                case '成品收获':
                    return 'harvest';
            }
        },
    }
}
</script>